import React from 'react';

import { BellOutlined } from '@ant-design/icons';

import NotifyPopup from '../../../components/Common/NotifyPopup';

// Общие колонки, есть на всех видах
// eslint-disable-next-line import/prefer-default-export
export const commonColumns = (notifyLastForRole) => ({
  name: null, // 'Характеристики', // название
  props: [], // список полей для запроса к серверу
  columns: [
    {
      prop: '_id',
      name: '',
      width: 35,
      align: 'center',
      excelHide: true,
      render: (item, val) => {
        const noti = notifyLastForRole[val];
        if (noti) return <NotifyPopup noti={noti} />;
        return <BellOutlined style={{ color: '#aaa' }} />;
      },
    },
    {
      prop: '+partNumber',
      name: 'Артикул',
      sort: true,
    },
    {
      prop: '+part',
      name: 'Деталь',
      sort: true,
      nowrap: true,
    },
    {
      prop: '+series',
      name: 'Серия KYB',
      sort: true,
    },
    {
      prop: '+type',
      name: 'Тип',
      sort: true,
      nowrap: true,
    },
    {
      prop: '+spec',
      name: 'Состав артикула',
      sort: true,
      nowrap: true,
    },
    {
      prop: '+fr',
      name: 'Передний / задний',
      sort: true,
      nowrap: true,
    },
    {
      prop: '+rl',
      name: 'Правый / левый',
      sort: true,
      nowrap: true,
    },
    {
      prop: '+changes',
      name: 'Возможная замена',
      sort: true,
    },
    {
      prop: '+amoProtect',
      name: 'Защитный комплект к амортизатору',
      sort: true,
    },
    {
      prop: '+fixType',
      name: 'Тип крепления / форма',
      sort: true,
    },
  ],
});
